import { useEffect } from "react";

export function useDelayedEffect(
    effect: React.EffectCallback,
    deps: React.DependencyList,
    timeout: number = 1000,
) {
    useEffect(() => {
        const timeoutId = setTimeout(effect, timeout);

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}